var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.942,
    height: 74.919,
    viewBox: "0 0 74.942 74.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "analysis",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362",
    transform: "translate(5.023 4.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M58.4,32.106a26.221,26.221,0,1,0,26.22,26.221A26.22,26.22,0,0,0,58.4,32.106Zm0,2.5A23.7,23.7,0,0,1,77.775,44.679L74.653,47.8a4.927,4.927,0,0,0-2.517-.712,4.994,4.994,0,0,0-4.994,4.994A4.928,4.928,0,0,0,67.85,54.6L59.674,62.78a4.842,4.842,0,0,0-5.042,0L48.954,57.1a4.928,4.928,0,0,0,.708-2.521,4.984,4.984,0,0,0-9.811-1.249H35.219A23.757,23.757,0,0,1,58.4,34.6Zm16.231,17.48a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,74.633,52.084ZM59.65,67.067a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,59.65,67.067ZM47.165,54.581a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,47.165,54.581ZM69.928,79.07A23.718,23.718,0,0,1,34.813,55.829h5.038a5,5,0,0,0,4.817,3.746,4.927,4.927,0,0,0,2.521-.708l5.678,5.679a4.928,4.928,0,0,0-.708,2.521,4.994,4.994,0,1,0,9.989,0,4.928,4.928,0,0,0-.708-2.521l8.176-8.176a4.928,4.928,0,0,0,2.521.708,4.994,4.994,0,0,0,4.994-4.994,4.928,4.928,0,0,0-.708-2.521l2.722-2.721A23.7,23.7,0,0,1,69.928,79.07Z",
    transform: "translate(-32.182 -32.106)",
    fill: "#000000"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M62.457,12.57a4.994,4.994,0,0,0,4.817-3.746h7.669v-2.5H67.274a4.984,4.984,0,0,0-9.811,1.249,4.928,4.928,0,0,0,.708,2.521l-2.194,2.194A31.214,31.214,0,1,0,48.183,57.5l3.768,3.768,1.765,1.766L63.768,73.082a6.546,6.546,0,0,0,9.257-9.257L62.974,53.774l-1.765-1.766L57.44,48.24a31.112,31.112,0,0,0,0-33.882l2.5-2.5A4.929,4.929,0,0,0,62.457,12.57Zm0-7.492a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,62.457,5.079Zm8.8,60.512A4.049,4.049,0,1,1,65.6,71.382l-.065-.065L55.483,61.266l5.726-5.726ZM59.443,53.774,53.717,59.5l-3.456-3.456c.176-.135.341-.283.514-.422s.375-.3.561-.461c.273-.23.543-.462.808-.7.136-.125.266-.25.4-.375q.768-.719,1.487-1.487c.125-.134.25-.263.375-.4.238-.265.471-.534.7-.808q.235-.277.461-.561c.137-.172.286-.337.421-.513Zm-4.842-5.8c-.393.549-.8,1.088-1.227,1.606-.125.151-.258.3-.387.446q-.573.667-1.184,1.294-.266.275-.541.541-.624.611-1.294,1.184c-.149.125-.295.261-.446.387-.518.428-1.056.834-1.606,1.227A28.763,28.763,0,1,1,54.6,47.974Z",
    transform: "translate(0 -0.08)",
    fill: "#000000"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/Analysis.5c8810054938ce63f7a8aed26899199b.svg";
export { ForwardRef as ReactComponent };